import { globalUtils } from '@gat-ship/utils'

export const appSessionId = globalUtils.functions.uuid()

export function getBaseApiUrl() {
  // Test mode wins regardless of build context. `vite build --mode test`
  // sets `import.meta.env.PROD = true` (Vite flags every build as PROD),
  // which would otherwise route API calls through the real VITE_API_URL
  // and bypass the Playwright `page.route('**/api/*')` mocks. The e2e
  // suite relies on the proxy-style relative path.
  if (import.meta.env.MODE === 'test') {
    return '/api/'
  }
  // Production
  if (import.meta.env.PROD ?? import.meta.env.MODE === 'production') {
    return import.meta.env['VITE_API_URL']
  }
  // Staging
  if (import.meta.env.MODE === 'staging') {
    return import.meta.env['VITE_API_URL']
  }
  // Development
  return '/api/'
}
